module.exports = __webpack_public_path__ + "static/media/circle12.27d71602.svg";